<template>
  <div
    :class="[$style.badge, { [$style.isSelected]: isSelected }]"
    @click="$emit('select', { id, isSelected: true })"
  >
    <div :class="$style.inner">
      <slot />
      <span
        :class="$style.iconWrapper"
        @click.stop="$emit('select', { id, isSelected: false })"
      >
        <CrossIcon
          v-if="isSelected"
          width="12px"
          height="12px"
          :class="$style.cross"
          class="icon-gray-1000"
        />
      </span>
    </div>
  </div>
</template>

<script>
import CrossIcon from 'LkIcons/Cross.vue'

export default {
  name: 'Badge',

  components: {
    CrossIcon,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
.badge {
  @include typo-sub-text;
  display: inline-block;
  margin: 10px 8px;
  padding: 5px 12px;
  border-radius: 24px;

  background-color: $gray-50;

  cursor: pointer;
}
.inner {
  display: flex;
  align-items: center;
}
.iconWrapper {
  display: flex;
  align-items: center;
}
.cross {
  margin-left: 6px;
}
.isSelected {
  font-weight: 500;

  background-color: $gray-100;
}
</style>
